module.exports = __webpack_public_path__ + "img/icon_Clock.adf80f90.svg";